export const getEmbedUrlFromYouTubeUrl = (url: string): string | null => {
  // get video id from youtube url "media"
  let videoId = extractVidoeIdFromYoutubeUrl(url)

  if (!videoId) {
    return null
  }

  const ampersandPosition = videoId.indexOf('&')
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition)
  } else {
    videoId = videoId.substring(0, videoId.length)
  }

  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?controls=0&rel=0&showinfo=0`
  return embedUrl
}

// https://stackoverflow.com/questions/71000139/javascript-regex-for-youtube-video-and-shorts-id
export const extractVidoeIdFromYoutubeUrl = (url: string) => {
  let regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm
  const result = regex.exec(url)
  return result ? result[3] : null
}
